export default function getAllMarkers(markersData) {
    return markersData
}
